export default __webpack_public_path__ + "static/media/img7.12b1e9e8.PNG";